import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import missingStateWarning from './missingStateWarning';
import createAppearance from './createAppearance';
var hoverState = '&:hover';
var activeState = '&:active';
var focusState = '&:focus';
/**
 * @param {object} items - object with a set of states.
 * @return {object} the final appearance.
 */

var createLinkAppearance = function createLinkAppearance() {
  var _objectSpread2;

  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  missingStateWarning({
    items: items,
    props: ['base', 'hover', 'active', 'focus'],
    cb: function cb(prop) {
      console.error("Themer.createLinkAppearance() is missing a ".concat(prop, " item"), items);
    }
  });
  return _objectSpread({}, items.base, (_objectSpread2 = {}, _defineProperty(_objectSpread2, hoverState, createAppearance(items.hover)), _defineProperty(_objectSpread2, activeState, createAppearance(items.active)), _defineProperty(_objectSpread2, focusState, createAppearance(items.focus)), _objectSpread2));
};

export default createLinkAppearance;